import { cva } from 'class-variance-authority'

import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { DocumentStatus } from '@/const/artifact-status.types'

const FILE_PROBLEM_BADGE =
  'text-main-foreground-tertiary bg-main-background-muted border-main-border-default'

export const documentStatusVariant = cva(
  'text-label-small flex w-fit items-center gap-1 h-6 justify-center whitespace-nowrap px-2 rounded',
  {
    variants: {
      status: {
        [DocumentStatus.PENDING]: 'bg-main-accent-100 text-main-foreground-accent',
        [DocumentStatus.CLASSIFYING]: 'text-main-accent-500',
        [DocumentStatus.COMPLETE]: 'text-main-foreground-success',
        [DocumentStatus.UNSPECIFIED]: '',
      },
      error: {
        [DocumentError.EMPTY]: FILE_PROBLEM_BADGE,
        [DocumentError.ENCRYPTED]: FILE_PROBLEM_BADGE,
        [DocumentError.UNKNOWN_CATEGORY]: FILE_PROBLEM_BADGE,
        [DocumentError.UNSUPPORTED_TYPE]: FILE_PROBLEM_BADGE,
        [DocumentError.UNKNOWN_COMPANY]: FILE_PROBLEM_BADGE,
        [DocumentError.NO_TEXT_EXTRACTED]: FILE_PROBLEM_BADGE,
        [DocumentError.UNKNOWN_ERROR]:
          'text-main-foreground-danger bg-semantic-danger-50 border-semantic-danger-100',
        [DocumentError.UNSPECIFIED]: '',
      },
      hoverable: {
        true: 'hover:bg-palette-gray-200',
        false: '',
      },
      highlighted: {
        true: '',
        false: 'bg-transparent border-none',
      },
    },
    defaultVariants: {
      highlighted: false,
      hoverable: false,
    },
  },
)
